import { render, staticRenderFns } from "./PasswordStrength.vue?vue&type=template&id=5921d1c9"
import script from "./PasswordStrength.vue?vue&type=script&lang=js"
export * from "./PasswordStrength.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports